import useTranslation from "next-translate/useTranslation";
import React from "react";
// import SegmentedControl from "./SegmentedControl";
// import styles from "./ChallengePopup.module.css";

export default function LiveOptions({
  setTime,
  time,
  setInc,
  inc,
  // setVariantId,
  // variantId,
  styles,
}) {
  const { t } = useTranslation("common");
  return (
    <>
      <div className="mt-5">
        <label className={styles.label}>{t("Time in minutes")}</label>
        <select
          onChange={(e) => setTime(Number(e.target.value))}
          defaultValue={time}
        >
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option>
          <option value="14">14</option>
          <option value="15">15</option>
          <option value="16">16</option>
          <option value="17">17</option>
          <option value="18">18</option>
          <option value="19">19</option>
          <option value="20">20</option>
          <option value="25">25</option>
          <option value="30">30</option>
          <option value="35">35</option>
          <option value="40">40</option>
          <option value="45">45</option>
          <option value="50">50</option>
          <option value="55">55</option>
          <option value="60">60</option>
        </select>
      </div>
      <div className="mt-5">
        <label className={styles.label}>{t("Increment in seconds")}</label>
        <select
          onChange={(e) => setInc(Number(e.target.value))}
          defaultValue={inc}
        >
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
        </select>
      </div>
    </>
  );
}
